/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment } from "react";

const DateEntityAttribute = (props) => {
    
    const name = props.name;
    const value = props.value;
    
    if (!value) {
        return null;
    }
    
    return (
        <>
            <div className="entity-attribute-editor-label">
                {name}
            </div>
            <div className="entity-attribute-editor-panel">
                {value}
            </div>

        </>
    );
};

DateEntityAttribute.displayName = "DateEntityAttribute";
export { DateEntityAttribute };
